import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { theme } from '../theme';
import { AsteriskIcon } from './AsteriskIcon';
export const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  gap: ${theme.spaces.x2};
`;
export const renderRequiredLabel = ({ label, required })=>{
    return label ? /*#__PURE__*/ _jsxs(StyledLabelWrapper, {
        children: [
            required && label && /*#__PURE__*/ _jsx(AsteriskIcon, {}),
            label
        ]
    }) : null;
};
